module.exports = __webpack_public_path__ + "img/ring_g_s_0_0.f799684f.png";